import axios from 'axios'

export const companiesVisitorStores = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    filteredCount: 0,
    filteredStores: [],
    errors: null
  },
  mutations: {
    readStores(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readStoresSuccess(state, payload) {
      state.data = payload
      state.loading = false
      state.loadError = false
    },
    readStoresFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.meta.filtered_store_count
      state.filteredStores = payload.data
    },
  },
  actions: {
    readStores({ commit }, payload) {
      const { companyUuid, params } = payload
      commit('readStores')
      axios
        .post(`/api/companies/${ companyUuid }/visitor/stores/search.json`, params)
        .then(res => {
          commit('readStoresSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('readStoresFailure', err)
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readStoresForFilter({ commit }, payload) {
      const { companyUuid, params } = payload
      return axios
        .post(`/api/companies/${ companyUuid }/visitor/stores/search.json`, params)
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    }
  }
}

